import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("fj_lang") || "en");

  useEffect(() => {
    localStorage.setItem("fj_lang", lang);
    document.documentElement.lang = lang;
    document.body.classList.toggle("lang-bn", lang === "bn");
  }, [lang]);

  const t = translations[lang];

  const toggleLang = () => setLang((prev) => (prev === "en" ? "bn" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
